<template>
  <div v-if="fetch_data">
    <div id="container" class="index">
      <!-- event list  -->
      <EventList :events="fetch_data.events" :storage_key="''"/>
    </div>
  </div>
</template>

<script>

import Libraries from '@/components/Libraries'
import EventList from '@/views/users/customer/elements/top/_event_list'

export default {
  mixins: [Libraries],
  components: {
    EventList,
  },
  data() {
    return {
      fetch_data: null,
    }
  },

  created() {
  },
  mounted() {
    // 休塾中/退塾中ならマイページへ
    if (this.isUserSleep() || this.isUserWithdrawal()) {
      this.$router.push({name: 'UsersCustomerAccount'})
      return
    }
    // 入塾前で入塾金未払いならマイページへ
    if (!this.isUserJoin() && !this.current_user.paid_join) {
      this.$router.push({name: 'UsersCustomerAccount'})
      return
    }
    this.fetchData()
  },

  watch: {
    $route(/*to, from*/) {
      if (location.hash) {
        setTimeout(() => {
          //this.scrollTo(location.hash)
          this.$scrollTo(location.hash, 0, {offset: -80})
        }, 300)
      }
    }
  },

  methods: {
    fetchData() {
      this.scrollTop()
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}users/events.json`, {
            params: {
              draft: this.$route.query.draft
            },
          })
          .then(response => {
            this.fetch_data = response.data
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.fetchDone()
            this.finishAjax()
          })
    },
    fetchDone() {
      // user js への onload処理
      if (typeof _million_onload !== 'undefined') {
        window._million_onload(this.fetch_data.uri);
      }
    },
  }
}
</script>

<style>
.sub_ttl[data-v-834c4d70] {
  cursor: pointer;
  pointer-events: none;
}
.sub_ttl.open[data-v-834c4d70]:after {
  display: none;
}
</style>
